import axiosInstance from "../axiosInstance";

// Get all social media platforms
export const getSocialMediaPlatformsAPI = async () => {
  try {
    console.log("Fetching social media platforms...");
    const response = await axiosInstance.get("/socialMedia");
    console.log("Social media response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Social media API error:", error);
    throw error.response?.data || error;
  }
};
